module.exports = __webpack_public_path__ + "media/images/notifications/icon_not_5-b6824139e66335c8509a3eac23ec0be3.svg";